import { Component, Inject, Input, OnInit, OnChanges, EventEmitter, Output, ViewChildren, QueryList, ElementRef } from "@angular/core";
import { DialogService } from "../../../../services/dialog.service";
import { HttpClient } from "@angular/common/http";
import { DefaultValuesService } from "../../../../services/defaultvalues.service";
import { MatDialog } from "@angular/material/dialog";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { MatTableDataSource } from "@angular/material/table";
import { SelectionModel } from "@angular/cdk/collections";
import { APICallStatus, Utils } from "../../../../utils/utils";
import { KpiDetailFormComponent } from "../../kpimanagement/kpidetail-form.component";
import { FilterUtils } from "../../shared-components/filter/filter-utils";


@Component({
    selector: "market-sheet-list",
    templateUrl: './market-sheet-list.component.html',
    styleUrls: ['./market-sheet-list.component.less',
        '../style/market-query.less',
        '../../../../style/new-generic-styles.component.less'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*', })),
            transition('expanded => collapsed', [animate('0ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
        ]),
    ],
    standalone: false
})

export class MarketSheetListComponent implements OnInit, OnChanges {
    @Input('list') list: KpiManagement[] = [];
    @Input('auxFilterPredicate') auxFilterPredicate!: (filters: string, data: any, parentLevel: boolean, showAllEnabled) => boolean;
    @Input('isEditModeEnabled') isEditModeEnabled: boolean = false;
    @Input('isShowAllEnabled') isShowAllEnabled: boolean = false;
    @Input('selectorKpiUnitFilter') selectorKpiUnitFilter = '0';
    @Input('filter') filter = '';

    @Input('isRevokeActive') isRevokeActive: boolean = false;
    @Input('isReleaseActive') isReleaseActive: boolean = false;
    @Output('onUpdateSelectorKpiUnit') onUpdateSelectorKpiUnit = new EventEmitter<{}>();

    @Output() onClickReleaseMode: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() onClickRevokeMode: EventEmitter<boolean> = new EventEmitter<boolean>();
    columnsToDisplay = ['arrow', 'Account', 'KpiName', 'KpiUnit', 'LocalCurrency'];

    kpiGroupingDimensions = ['line of business', 'product type', 'scope'];

    public dataSource = new MatTableDataSource<KpiManagement>();

    @ViewChildren('stickyColumn') stickyColumns?: QueryList<ElementRef>;
    @ViewChildren('stickyColumnData') stickyColumnsData?: QueryList<ElementRef>;

    expandedElements = new Set();
    isAllCollapsed = false;
    Filter = 0;

    updatedItems: KpiManagementUpdate[] = []
    releaseList: selectedReleaseRow[] = []

    selection = new SelectionModel<UserSummary>(true, []);

    currentFY: string | undefined;
    FY1: string | undefined;
    FY2: string | undefined;
    FY3: string | undefined;

    tableResponseState: APICallStatus = APICallStatus.NotRequested;

    constructor(
        private http: HttpClient
        , private dialogService: DialogService
        , private defaults: DefaultValuesService
        , @Inject('BASE_URL') private baseUrl: string
        , private dialogForm: MatDialog

    ) {
    }

    ngOnChanges(changes: any) {
        this.getFiscalYearHeaders()
        if (changes.list) {
            this.dataSource.data = this.list;
        }

        if (this.selectorKpiUnitFilter === '1')
            this.columnsToDisplay = ['arrow', 'Account', 'KpiName', 'KpiUnit'];
        else
            this.columnsToDisplay = ['arrow', 'Account', 'KpiName', 'KpiUnit', 'LocalCurrency'];

        this.updatedItems = [];

        if (changes.filter || changes.inclusiveFilter || changes.selectorFilter || (changes.list && this.filter)) {
            this.dataSource.filter = this.filter;
        }
    }

    ngOnInit() {
        this.dialogService.tthis = this;
        this.dataSource.filterPredicate = (data: KpiManagement, filters: string) => {
            const filterList = filters ? filters.split('+').map(f => f.trim()).filter(f => f) : [];
            filterList.pop();
            filterList.pop();
            filterList.pop();
            filterList.pop();

            if (filterList.length === 0) {
                if (data.subtable) {
                    data.subtable.filter = '__FORCE__';
                } else {
                    this.createMatSubtable(data);
                    data.subtable.filter = '__FORCE__';
                }
                return this.auxFilterPredicate('__FORCE__', data, true, this.isShowAllEnabled)
            }
            
            return FilterUtils.applyCommonFilterLogic(
                data,
                filterList,
                this.dataSource,
                this.auxFilterPredicate.bind(this),
                this.createMatSubtable.bind(this),
                this.isShowAllEnabled
            );
        };
    }

    ngAfterViewInit() {
        this.setStickyColumnPositions();
    }

    ngAfterViewChecked() {
        this.setStickyColumnPositions();
    }

    setStickyColumnPositions() {
        if (this.list?.length > 0) {
            this.list.forEach((account, accountIndex) => {
                const accountContainerId = `table-account-${account.AccountID}`;
                const headerElements = this.stickyColumns?.filter((element) => {
                    const parentContainer = element.nativeElement.closest(`#${accountContainerId}`);
                    return parentContainer !== null;
                });
                if (headerElements != undefined && headerElements.length > 0) {
                    const rowCount = this.list[accountIndex].KpiDetail.length;
                    let leftOffset = -1;
                    const dataElements = this.stickyColumnsData?.filter((element) => {
                        const parentContainer = element.nativeElement.closest(`#${accountContainerId}`);
                        return parentContainer !== null;
                    });

                    headerElements.forEach((column, index) => {
                        if (index > 0) {
                            const previousColumn = headerElements[index - 1].nativeElement;
                            leftOffset += previousColumn.clientWidth -1;
                        }
                        else
                            column.nativeElement.style.minWidth = '30px';
                        column.nativeElement.style.position = 'sticky';
                        column.nativeElement.style.left = `${leftOffset}px`;
                        column.nativeElement.style.zIndex = '100';
                    });

                    if (dataElements != undefined && dataElements.length > 0) {
                        dataElements.forEach((elem, index) => {
                            const headerIndex = Math.floor(index / rowCount);
                            elem.nativeElement.style.position = 'sticky';
                            elem.nativeElement.style.left = headerElements[headerIndex].nativeElement.style.left;
                        });
                    }
                }
            });
        }
    }

    checkExpanded(element) {
        return this.expandedElements.has(element);
    }

    pushPopElement(element) {
        if (this.expandedElements.has(element)) {
            this.expandedElements.delete(element);
        }
        else {
            this.expandElement(element)
            if (!element.subtable) {
                this.createMatSubtable(element)
            }
        }
    }

    collapseOrExpandAll() {
        if (this.isAllCollapsed === false) {
            this.isAllCollapsed = true;
            this.dataSource.data.forEach((el) => {
                if (!this.expandedElements.has(el)) {
                    if (!el.subtable)
                        this.createMatSubtable(el)
                    this.expandElement(el)
                }
            })
        }
        else {
            this.isAllCollapsed = false;
            this.expandedElements.clear()
        }
    }

    private createMatSubtable(el: any) {
        let dataSource = new MatTableDataSource<any>();
        dataSource.data = el.KpiDetail
        dataSource.filterPredicate = (data2: any, filters: string) => {
            return this.auxFilterPredicate(filters, data2, false, this.isShowAllEnabled)
        }
        el.subtable = dataSource;
    }

    private expandElement(el: any) {
        this.expandedElements.add(el);
    }

    formatCurrency(value, decimalDigits): string {
        if (value == undefined)
            return '';
        else
            return parseFloat(value).toLocaleString('en-US', { maximumFractionDigits: decimalDigits });
    }


    onChange(breakdown: any, account: any, field: string, $e: any) {
        let pM1 = 0

        let tempObject: KpiManagementUpdate = {
            'KpiId': breakdown.KpiId,
            'KpiDefinitionId': breakdown.KpiDefinitionId,
            'KpiVersion': 'MARKET',
            'KpiBreakdown1Id': breakdown.KpiBreakdown1Id,
            'KpiBreakdown2Id': breakdown.KpiBreakdown2Id,
            'KpiMovementTypeId': breakdown.KpiMovementTypeId,
            'KpiProductHierarchyId': breakdown.KpiProductHierarchyId,
            'KpiValue': $e,
            KpiUnit: account.KpiUnit,
            AccountId: account.AccountID,
            ApprovalStatus: "",
            DecimalDigits: 0,
            auxFYFC: "",
            IsAccumulative: false,
            Field: field
        }
        this.addUpdatedItem(tempObject);
    }

    private addUpdatedItem(newObject: KpiManagementUpdate) {
        const index = this.updatedItems.findIndex(
            (obj) =>
                obj.KpiDefinitionId === newObject.KpiDefinitionId &&
                obj.KpiBreakdown1Id === newObject.KpiBreakdown1Id &&
                obj.KpiBreakdown2Id === newObject.KpiBreakdown2Id &&
                obj.KpiId === newObject.KpiId &&
                obj.KpiVersion === newObject.KpiVersion &&
                obj.KpiMovementTypeId === newObject.KpiMovementTypeId &&
                obj.KpiProductHierarchyId === newObject.KpiProductHierarchyId &&
                obj.Field === newObject.Field
        );

        if (index !== -1) {
            if (newObject.KpiValue === 'NaN')
                this.updatedItems.splice(index, 1)
            else
                this.updatedItems[index] = newObject;
        } else {
            this.updatedItems.push(newObject);
        }
    }

    disableArrowKeys(event: KeyboardEvent) {
        if (
            event.key === 'ArrowUp' ||
            event.key === 'ArrowDown'
        ) {
            event.preventDefault();
        }
    }

    private getFiscalYearHeaders() {
        this.FY3 = (this.defaults.fiscalYear + 3).toString() + '/' + (this.defaults.fiscalYear + 4).toString();
        this.FY2 = (this.defaults.fiscalYear + 2).toString() + '/' + (this.defaults.fiscalYear + 3).toString();
        this.FY1 = (this.defaults.fiscalYear + 1).toString() + '/' + (this.defaults.fiscalYear + 2).toString();
        this.currentFY = (this.defaults.fiscalYear).toString() + '/' + (this.defaults.fiscalYear + 1).toString();
    }

    public getYoYValue(previousYearValue: number, currentYearValue: number): string | undefined {
        if (previousYearValue != undefined && currentYearValue != undefined) {
            if (previousYearValue === 0)
                return undefined;
            else
                return `${((currentYearValue - previousYearValue) * 100 / previousYearValue).toLocaleString('en-US', { maximumFractionDigits: 2 })}%`;
        }
        else return undefined;
    }

    public getAvgSellingPriceValue(breakdown: any, field: string) {
        if (breakdown["COL1"] !== 'MOD') {
            let valuesInThousands: number | undefined;
            let units: number | undefined;
            switch (breakdown.MersyId) {
                case "MQ000001":
                    valuesInThousands = breakdown[field];
                    units = this.dataSource.data.find(obj => obj.AccountID === 'MQ000002')?.KpiDetail.find(obj => obj.Granularity === breakdown.Granularity)[field];
                    break;
                case "MQ000002":
                    valuesInThousands = this.dataSource.data.find(obj => obj.AccountID === 'MQ000001')?.KpiDetail.find(obj => obj.Granularity === breakdown.Granularity)[field];
                    units = breakdown[field];
                    break;
                case "MQ000003":
                    valuesInThousands = breakdown[field];
                    units = this.dataSource.data.find(obj => obj.AccountID === 'MQ000004')?.KpiDetail.find(obj => obj.Granularity === breakdown.Granularity)[field];
                    break;
                case "MQ000004":
                    valuesInThousands = this.dataSource.data.find(obj => obj.AccountID === 'MQ000003')?.KpiDetail.find(obj => obj.Granularity === breakdown.Granularity)[field];
                    units = breakdown[field];
                    break;
            }

            if (valuesInThousands == undefined || units == undefined || units === 0) {
                return undefined;
            }

            return valuesInThousands / units;
        }
        else {
            return undefined;
        }
    }

    public getPercentageValue(kpi: any, breakdown: any, field: string): string | undefined {
        if (kpi.subtable && field && breakdown) {

            if (kpi.COL1_NAME === 'Scope' && breakdown.COL1 === 'TKE')
                return '---';
            if (kpi.COL2_NAME === 'Scope' && breakdown.COL2 === 'TKE')
                return '---';
            if (kpi.COL3_NAME === 'Scope' && breakdown.COL3 === 'TKE')
                return '---';
            if (kpi.COL4_NAME === 'Scope' && breakdown.COL4 === 'TKE')
                return '---';


            var sum = kpi.subtable._data._value
                //.filter(x => x.KpiBreakdown1Id === breakdown.KpiBreakdown1Id)
                .filter(x =>
                    (this.kpiGroupingDimensions.includes(kpi.COL1_NAME.toLowerCase()) ? x.COL1.toLowerCase() === breakdown.COL1.toLowerCase() : true) &&
                    (this.kpiGroupingDimensions.includes(kpi.COL2_NAME.toLowerCase()) ? x.COL2.toLowerCase() === breakdown.COL2.toLowerCase() : true) &&
                    (this.kpiGroupingDimensions.includes(kpi.COL3_NAME.toLowerCase()) ? x.COL3.toLowerCase() === breakdown.COL3.toLowerCase() : true) &&
                    (this.kpiGroupingDimensions.includes(kpi.COL4_NAME.toLowerCase()) ? x.COL4.toLowerCase() === breakdown.COL4.toLowerCase() : true)
                )
                .map(x => x[field] ?? 0 as number)
                .reduce(function (res, el) {
                    return res + el
                }, 0)

            if (breakdown[field] != undefined) {
                if (sum > 0)
                    return `${((breakdown[field] / sum) * 100).toLocaleString('en-US', { maximumFractionDigits: 2 })}%`;
                else if (breakdown[field] === 0)
                    return '0 %';
                else
                    return '100%'
            }


            return undefined
        }
        else return undefined
    }

    public filterKpiUnit(value: any) {
        this.onUpdateSelectorKpiUnit.emit(value.value)
    }
    public cellTolltipValue(accountUnit) {
        return accountUnit === 'Values' ? 'Value in thousands' : ''
    }

    getHeaderWithComparison(fiscalYear: string | undefined, type: string) {
        return `${fiscalYear} ${type}`
    }

    canBeReleased(breakdown: any) {
        const validFields = [
            { value: breakdown.PYBUD, status: breakdown.ApprovalStatus },
            { value: breakdown.FY1BUD, status: breakdown.ApprovalStatus_FY1 },
            { value: breakdown.FY2BUD, status: breakdown.ApprovalStatus_FY2 },
            { value: breakdown.FY3BUD, status: breakdown.ApprovalStatus_FY3 }
        ].filter(field => Utils.IsValidNumber(field.value));

        if (validFields.length === 0) {
            return false;
        }

        const allValidFieldsReleased = validFields.every(field => field.status === 'RELEASED');
        
        if (allValidFieldsReleased) {
            return false;
        }

        return validFields.some(field => field.status === 'NEW' || field.status === 'REVOKED');
    }

    canBeRevoked(breakdown: any) {
        return breakdown.ApprovalStatus == 'RELEASED'            
            || breakdown.ApprovalStatus_FY1 == 'RELEASED'
            || breakdown.ApprovalStatus_FY2 == 'RELEASED'
            || breakdown.ApprovalStatus_FY3 == 'RELEASED'
    }

    mapReleaseRow(row) {
        var selectedReleaseRow: selectedReleaseRow = {
            KpiDefinitionId: row.KpiDefinitionId,
            KpiMovementTypeId: row.KpiMovementTypeId,
            KpiProductHierarchyId: row.KpiProductHierarchyId,
            KpiBreakdown1Id: row.KpiBreakdown1Id,
            KpiBreakdown2Id: row.KpiBreakdown2Id

        };
        return selectedReleaseRow;
    }

    accountCheckboxCheck(row) {
        const actionableItems = row.KpiDetail.filter((item) => {
            return this.isReleaseActive ? this.canBeReleased(item) : this.canBeRevoked(item);
        });
        if (actionableItems.length === 0) return false;
        const checked = actionableItems.every((item) => {
            const mappedRow = this.mapReleaseRow(item);
            return this.releaseList.some((object) => this.objectsEqual(mappedRow, object));
        });
        return checked;
    }
    
    accountItemsIndetermine(row) {
        var Indeterminate = this.releaseList.some((selected) => (selected.KpiDefinitionId === row.KpiDefinitionId))
        return Indeterminate;
    }
    accountItemsDisable(row) {
        var Disable = !row.KpiDetail.some((item) => {
            return (this.isReleaseActive ? this.canBeReleased(item) :
                this.canBeRevoked(item))
        }
        )
        return Disable;
    }

    accountItemsSelected(ischecked, row) {
        row.KpiDetail.forEach((item) => {
            if (this.isReleaseActive) {
                if (this.canBeReleased(item)) {
                    this.expandedItemSelected(ischecked, item);
                }
            } else {
                if (this.canBeRevoked(item)) {
                    this.expandedItemSelected(ischecked, item);
                }
            }
        });
    }
    
    expandedItemSelected(ischecked, row) {
        if ((this.isReleaseActive && this.canBeReleased(row)) || (this.isRevokeActive && this.canBeRevoked(row))) {
            var selectedReleaseRow = this.mapReleaseRow(row);
            if (ischecked) {
                this.selection.select(row)
                this.onSelect(selectedReleaseRow);
            } else {
                this.selection.deselect(row)
                this.onDeselect(selectedReleaseRow);
            }
        }

    }
    onSelect(selectedReleaseRow) {
        //this.releaseList.push(selectedReleaseRow)

        if (!this.releaseList.some((object) => this.objectsEqual(object, selectedReleaseRow))) {
            this.releaseList.push(selectedReleaseRow)
        }

    }
    onDeselect(selectedReleaseRow) {
        var mappedRow = this.mapReleaseRow(selectedReleaseRow)
        const index = this.releaseList.findIndex((object) => this.objectsEqual(mappedRow, object));
        if (index !== -1) {
            this.releaseList.splice(index, 1);
        }
    }

    objectsEqual(object1, object2) {
        if (object1 === object2) {
            return true;
        }
        if (Object.keys(object1).length !== Object.keys(object2).length) {
            return false;
        }
        for (const property in object1) {
            if (object1[property] !== object2[property]) {
                return false;
            }
        }
        return true;
    }
    getSelectionList() {
        return this.releaseList;
    }
    clearSelectionList() {
        this.releaseList = [];
        this.selection?.clear();
    }
    onClickReleaseMode_emitter() {
        this.onClickReleaseMode.emit();
    }
    onClickRevokeMode_emitter() {
        this.onClickRevokeMode.emit();
    }
    anyActionableItemExist() {
        return this.selection.hasValue() && (this.isReleaseActive ? 
            this.list.some((kpi) => kpi.KpiDetail.some((kpidef) => (kpidef.ApprovalStatus == "NEW" || kpidef.ApprovalStatus_FY1 == "NEW" || kpidef.ApprovalStatus_FY2 == "NEW" || kpidef.ApprovalStatus_FY3 == "NEW"))) :
            this.list.some((kpi) => kpi.KpiDetail.some((kpidef) => (kpidef.ApprovalStatus == "RELEASED" || kpidef.ApprovalStatus_FY1 == "RELEASED" || kpidef.ApprovalStatus_FY2 == "RELEASED" || kpidef.ApprovalStatus_FY3 == "RELEASED"))))
    }
    textRelRevbuttonState() {
        return this.anyActionableItemExist() && this.selection.hasValue() ?
            (((this.isReleaseActive || this.isRevokeActive && this.isReleaseActive) ? 'Release ' : 'Revoke ') + (!this.selection.hasValue() ? 'All' : 'Selected')) :
            (this.isReleaseActive ? 'Nothing to Release' : 'Nothing to Revoke')
    }

    onHistoryDetail(element: any) {

        var KpiId = "null";

        if (element.KpiId != undefined)
            KpiId = element.KpiId;

        const Dialog = this.dialogForm.open(KpiDetailFormComponent, {
            panelClass: 'custom-mat-dialog',
            disableClose: false,
            data: {
                "KpiDefinitionId": element.KpiDefinitionId,
                "KpiId": KpiId,
                "DataType": 'MARKET',
                "kpiHistoryLogDialogTags": element.kpiHistoryLogDialogTags
            }
        });
        Dialog.afterClosed().subscribe(() => {
        });

    }

    showIndividualHistory(element: any) {
        return element.KpiId != undefined
    }


    onBack() { }
}
export interface SearchItem {
    name: string;
}
